"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _excluded = ["children", "className", "feedback", "spritemap", "value", "warn"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayProgressBar = function ClayProgressBar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$feedback = _ref.feedback,
      feedback = _ref$feedback === void 0 ? false : _ref$feedback,
      spritemap = _ref.spritemap,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      warn = _ref.warn,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  "production" !== "production" ? (0, _warning.default)(value >= 0 && value <= 100, "ClayProgressBar requires `value` to be in the range of 0 to 100, it received ".concat(value, ".")) : void 0;
  value = Math.min(Math.max(value, 0), 100);
  var addon = children || (value === 100 ? /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "check-circle"
  }) : "".concat(value, "%"));

  if (value === 100 || feedback) {
    addon = /*#__PURE__*/_react.default.createElement("div", {
      className: "progress-group-feedback"
    }, addon);
  }

  var status;

  if (warn) {
    status = 'warning';
  } else if (value === 100) {
    status = 'success';
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'progress-group', _defineProperty({}, "progress-".concat(status), status))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "progress"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": value,
    className: "progress-bar",
    role: "progressbar",
    style: {
      width: "".concat(value, "%")
    }
  })), addon && /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-group-addon"
  }, addon));
};

var _default = ClayProgressBar;
exports.default = _default;